import { Box, Stack, Typography } from "@mui/material";

export const SkuRankingsEmpty = () => {
  return (
    <Stack justifyContent="center" alignItems="center" gap={3} sx={{ py: 6 }}>
      <Box
        component="img"
        src="./img/empty.svg"
        alt="Nenhum ranking encontrado"
        sx={{ width: 220, maxWidth: "80%" }}
      />
      <Stack gap={0} alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          Nenhum ranking encontrado
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          Ajuste os filtros para exibir os rankings de SKU.
        </Typography>
      </Stack>
    </Stack>
  );
};
